import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  SvgIcon,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
} from '@material-ui/core'
import { mdiContentSave, mdiDeleteForever } from '@mdi/js'

import UserSelectContainer from './UserSelectContainer'
import UserNameContainer from './UserNameContainer'

const defaultUser = {
  name: '',
  email: '',
  user_id: '',
  role_id: '',
  subscribed: false,
}

class CommunityUsersView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    community: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: theme.spacing(3),
    }),
  })

  state = {
    user: defaultUser,
  }

  handleSaveClick = () => {
    const users = (this.props.community.users || []).concat(this.state.user)
    const community = {
      id: this.props.community.id,
      users,
    }
    // Add the new user
    this.props.onSave(community)
    this.setState({ user: defaultUser })
  }

  handleRemoveClick = (userId) => {
    const users = this.props.community.users.filter((user) => user.user_id !== userId)
    const community = {
      id: this.props.community.id,
      users,
    }
    this.props.onSave(community)
  }

  handleUserSelect = (selected) => {
    // eslint-disable-next-line camelcase
    const user_id = selected ? selected.user_id : ''
    const name = selected ? selected.name : ''
    const email = selected ? selected.email : ''

    this.setState(
      (prevState) => ({
        user: {
          ...prevState.user,
          user_id,
          name,
          email,
        },
      }),
    )
  }

  handleRoleIdChange = (e) => {
    // eslint-disable-next-line camelcase
    const role_id = e.target.value

    this.setState(
      (prevState) => ({
        user: {
          ...prevState.user,
          role_id,
        },
      }),
    )
  }

  handleSubscriptionChange = (e) => {
    const { checked } = e.currentTarget

    this.setState(
      (prevState) => ({
        user: {
          ...prevState.user,
          subscribed: checked,
        },
      }),
    )
  }

  render() {
    const { community, roles, classes } = this.props
    const { user } = this.state

    const addUserHtml = (
      <TableRow key="new">
        <TableCell>
          {
            community.organization_id
            && (
              <UserSelectContainer
                organizationId={community.organization_id}
                selected={user}
                onSelect={this.handleUserSelect}
              />
            )
          }
        </TableCell>
        <TableCell>
          <Select value={user.role_id} autoWidth onChange={this.handleRoleIdChange}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {Object.values(roles).map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </TableCell>
        <TableCell>
          <Checkbox name="subscribed" checked={user.subscribed} onChange={this.handleSubscriptionChange} />
        </TableCell>
        <TableCell>
          <IconButton aria-label="Save" onClick={this.handleSaveClick}>
            <SvgIcon>
              <path d={mdiContentSave} />
            </SvgIcon>
          </IconButton>
        </TableCell>
      </TableRow>
    )

    const users = community.users || []
    return (
      <Paper className={classes.paper} elevation={0}>
        <Typography variant="h6">Users</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Alert subscription</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {addUserHtml}
            {
              users.map((u) => (
                <TableRow key={u.user_id}>
                  <TableCell><UserNameContainer userId={u.user_id} /></TableCell>
                  <TableCell>{(roles[u.role_id] || { name: '' }).name}</TableCell>
                  <TableCell><Checkbox disabled name="subscribed" checked={u.subscribed} /></TableCell>
                  <TableCell>
                    <IconButton aria-label="Remove" onClick={() => this.handleRemoveClick(u.user_id)}>
                      <SvgIcon>
                        <path d={mdiDeleteForever} />
                      </SvgIcon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(CommunityUsersView.styles)(CommunityUsersView)
